define('widgets/frames',[
	'jquery',
	'widgets/slides'
], function ($, slides) {

	var newline = /\s*<br>\s*/;
	var whitespace = / /;

	return $.widget('muse.frames', slides, {

		options: {
			slide: '.frame',
			className: null,
			hash: false
		},

		current: {},

		_additionalWidth: 0,

		_create: function () {

			var words = [];

			this._super();

			this.$frame = this.$slides.first().clone();
			this.$text = this.$frame.find('.text');

			if (this.element.data('text')) {
				this.text = this.element.data('text');
				this.$slides.remove();
			} else {
				this.text = this.$text.html();
				this.element.attr('data-text', this.text);
			}
			this.$text.empty();

			this.lines = this.text.split(newline);

			$.each(this.lines, function (i, line) {
				words[i] = line.split(whitespace);
			});
			this.words = words;
			// this.render();

		},

		render: function () {

			var pos;

			this.$slides.remove();
			this.$slides = null;

			this.current.line = 0;
			this.current.word = 0;

			this.maxHeight = null;
/*
			this.element.css({
					position: '',
					left: '',
					// top: '',
					width: '',
					'margin-left': '',
					// 'margin-top': '',
					'margin-right': ''
				});
*/
			this.addFrame();

			this.$current = this.$slides.first();

			this.resize();
/*
			pos = this.element.position();
			pos.left += parseInt(this.element.css('margin-left'));

			// pos.top += parseInt(this.element.css('margin-top'));

			this.element.css({
				position: 'relative',
				left: 0,
				// top: 0,
				width: 'auto',
				'margin-left': pos.left,
				// 'margin-top': pos.top,
				'margin-right': pos.left
			});
*/
		},

		addFrame: function () {

			var $frame = this.$frame.clone().appendTo(this.$wrap),
				$text = $frame.find('.text');

			// console.log('add frame');

			this.current.$frame = $frame;
			this.current.$text = $text;
			this.current.text = '';

			this.$slides = $frame.add(this.$slides);

			this.maxHeight = this.maxHeight || $frame.height();
			if (!this.maxHeight)
				return true;

			if (this.current.word > 0) {
				if (this.addWords() && this.current.line >= this.lines.length - 1) {
					$text.html(this.current.text);
					return true;
				} else {
					this.current.line++;
				}

			}

			if (!this.addLines()) {

				this.current.text += '<br>';
				if (this.addWords())
					this.current.line++;

				return this.addFrame();

			} else {
				$text.html(this.current.text);
			}

			return true;

		},

		addLines: function () {

			// console.log('add lines ', this.lines.slice(this.current.line));

			return this.add('line', this.lines, '<br>');

		},

		addWords: function () {

			var words = this.words[this.current.line];

			// console.log('add words', words.slice(this.current.word));

			return this.add('word', words, ' ');

		},

		add: function (type, all, spacer) {

			var $text = this.current.$text,
				text = this.current.text,
				offset = this.current[type],
				more = false,
				space = '',
				current, height;

			for (i = offset; i < all.length; i++) {

				space = text ? spacer : '';
				current = all[i];
				height = $text.html(text + space + current).height();

				this.current[type] = i;

				if (height < this.maxHeight) {
					text += space + current;
					this.current.text = text;
				} else {
					$text.html(text);
					more = true;
					break;
				}

			}

			if (!more) {
				this.current[type] = 0;
			}

			return !more;

		},

		goTo: function () {},

	});

});
